// Italian translations
export const it = {
  // Common
  common: {
    home: 'Home',
    settings: 'Impostazioni',
    language: 'Lingua',
    loading: 'Caricamento...',
    save: 'Salva',
    cancel: 'Annulla',
    confirm: 'Conferma',
    close: 'Chiudi',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Impostazioni',
    home: 'Home',
    howToPlay: 'Come Giocare',
    pieceRules: 'Regole dei Pezzi',
    language: 'Lingua',
    manageSubscription: 'Gestisci Abbonamento',
    gameHistory: 'Cronologia Partite',
    analytics: 'Statistiche',
    premiumAccount: 'Account Premium',
    chatEnabled: 'Chat: Attiva',
    chatDisabled: 'Chat: Disattivata',
  },

  // Piece Rules
  pieceRules: {
    title: 'Regole dei Pezzi',
    description: 'Impara i movimenti dei pezzi',
    selectPiece: 'Seleziona Pezzo',
    selectedLabel: 'Selezionato:',
    statusLabel: 'Stato:',
    statusReady: 'Pronto',
    statusViewing: 'Visualizzazione',
    movement: 'Movimento',
    regularMovement: 'Movimento Regolare',
    ability: 'Abilità',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Movimento',
    savage: 'Selvaggio',
    birdtype: 'Tipo Uccello',
    birdType: 'Tipo Uccello',
    wallBlock: 'Blocco Muro',
    moveblocks: 'Blocchi Movimento',
    wallclimb: 'Scalata Muro',
    lilypad: 'Ninfea',
    poisonous: 'Velenoso',
    meadow: 'Prato',
    parasiticfungi: 'Funghi Parassiti',
    zombification: 'Zombificazione',
    fungi: 'Funghi',
    traverse: 'Attraversamento',
    capture: 'Cattura',
    faint: 'Svenimento',
    leap: 'Salto',
    swing: 'Oscillazione',
    consume: 'Consumo',
    gamble: 'Azzardo',
    entangle: 'Intrappolamento',
    ink: 'Inchiostro',
    rotate: 'Rotazione',
    backstep: 'Passo Indietro',
    trample: 'Calpestamento',
    charge: 'Carica',
    lane: 'Corsia',
    snakestrike: 'Colpo del Serpente',
    shedskin: 'Muta della Pelle',
    house: 'Casa',
    plant: 'Tipo Pianta',
    planttype: 'Tipo Pianta',
    capturehost: 'Cattura Ospite',
    contagion: 'Contagio',
    lonewolf: 'Lupo Solitario',
    hop: 'Balzo',
    decay: 'Decomposizione',
    slide: 'Scivolata',
    block: 'Blocco',
    poison: 'Veleno',
    infection: 'Infezione',
    howl: 'Ululato',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'L\'Orso può muoversi di una casella in qualsiasi direzione, come un re negli scacchi',
    bearMovementPost: 'È bloccato solo dai pezzi alleati (eccetto gli Alberi, gli Orsi possono arrampicarsi sugli Alberi!)',
    bearSavage: 'Un Orso può superare abilità difensive come il Blocco del Rinoceronte',
    bearSavagePost: 'Usando Selvaggio, l\'Orso può catturare qualsiasi pezzo da qualsiasi direzione, aggiungendo letalità',

    // Crane
    craneMovement: 'La Gru può muoversi di 1 o 2 caselle in qualsiasi linea retta',
    craneMovementPost: 'La Gru può persino volare sopra altri pezzi!',
    craneBirdType: 'I pezzi di tipo uccello non possono catturare pezzi grandi o predatori',
    craneBirdTypePost: 'Questo include Albero, Rinoceronte, Orso e Lupo',

    // Frog
    frogMovement: 'La Rana salta 2 caselle in diagonale',
    frogMovementPost: 'Non può saltare solo una casella',
    frogWallBlock: 'Se il percorso regolare di 2 caselle della Rana è bloccato da un muro o un altro pezzo, non può catturare',
    frogWallBlockPost: 'Il suo movimento regolare si accorcia a 1 casella in diagonale',
    frogWallClimb: 'Quando la Rana è sul muro del tabellone (Colonna A o E) può muoversi su o giù di uno',
    frogWallClimbPost: 'A meno che non sia bloccata da un pezzo alleato o un Rinoceronte davanti alla Rana',
    frogLilypad: 'Se la Rana non si è ancora mossa in una partita, può spostarsi a una qualsiasi delle prime 3 file come potente abilità difensiva',
    frogLilypadPost: 'Può catturare qualsiasi pezzo regolare usando il Salto della Ninfea, eccetto un Rinoceronte su una fila più alta di sé',
    frogPoisonous: 'Quando un animale cattura un pezzo Rana, diventi avvelenato!',
    frogPoisonousPost: 'Un pezzo avvelenato salta il suo prossimo turno disponibile prima di riprendersi',

    // Fungi
    fungiMovement: 'I Funghi possono muoversi di una casella in qualsiasi direzione',
    fungiMovementPost: 'Sono bloccati solo dai pezzi alleati',
    fungiMeadow: 'I Funghi riducono la capacità di movimento del pezzo Albero nemico',
    fungiMeadowPost: 'Il pezzo Albero nemico non può muoversi entro 1 casella dal pezzo Funghi',
    fungiParasitic: 'I Funghi possono immobilizzare il pezzo Albero nemico',
    fungiParasiticPost: 'Se i Funghi sono entro 1 casella dall\'Albero nemico, non può muoversi finché i Funghi non si allontanano o vengono catturati',
    fungiZombification: 'I Funghi possono zombificare qualsiasi pezzo animale nemico che li cattura, permettendo il controllo dell\'animale nemico per un turno',
    fungiZombificationPost: 'Il pezzo zombificato è considerato anche il pezzo Funghi per quel turno, anche se i Funghi erano il tuo re la partita non finisce fino a dopo quel turno',
    fungiFungi: 'Fungo',
    fungiFungiPost: 'Come veleno, intrappolamento e infezione da virus, ma non zombificazione poiché possono zombificare altri!',

    // Goat
    goatMovement: 'La Capra può muoversi di una casella in qualsiasi direzione',
    goatMovementPost: 'La Capra si muove lentamente ma ha abilità potenti',
    goatTraverse: 'La Capra può attraversare qualsiasi altro pezzo connesso per creare un enorme potenziale di movimento',
    goatTraversePost: 'La Capra non può attraversare Capre Svenute o pezzi Piccoli come il Virus',
    goatCapture: 'La Capra non può catturare alcun Predatore',
    goatCapturePost: 'Come Orso o Lupo',
    goatFaint: 'La Capra può svenire per evitare la cattura eccetto da pezzi grandi come Albero e Rinoceronte',
    goatFaintPost: 'Mentre svenuta, gli avversari possono "stare" sulla capra svenuta per fermare il suo movimento',

    // Monkey
    monkeyMovement: 'La Scimmia può muoversi di una casella in qualsiasi direzione',
    monkeyMovementPost: 'Senza altri pezzi da utilizzare, la Scimmia ha movimento limitato',
    monkeyLeap: 'La Scimmia, come nel gioco della dama, può saltare sopra altri pezzi in linea retta per un enorme potenziale di movimento',
    monkeyLeapPost: 'Ma se salta sopra un pezzo nemico, la Scimmia deve tirare un dado per sopravvivere al salto, 1/6 di possibilità di cattura per ogni nemico che salta!',
    monkeySwing: 'Se una Scimmia usa un salto sopra un Albero, la Scimmia ottiene un turno bonus',
    monkeySwingPost: 'Usare l\'Oscillazione dell\'Albero crea una potente combo sinergica tra la Scimmia e il pezzo Albero',
    monkeyConsume: 'La Scimmia può consumare un pezzo Funghi per un turno bonus',
    monkeyConsumePost: 'Portando a combinazioni devastanti quando combinato con altri turni bonus',
    monkeyGamble: 'Oltre a tirare un dado per saltare sopra i nemici, la Scimmia deve azzardare per catturare l\'Orso',
    monkeyGamblePost: 'La scimmia deve tirare un 5 o un 6 su un dado a 6 facce per catturare l\'Orso o viene catturata essa stessa',

    // Octopus
    octopusMovement: 'Il Polpo si muove di una casella in qualsiasi direzione',
    octopusCapture: 'Il Polpo può catturare solo ortogonalmente',
    octopusCapturePost: 'Il polpo può catturare o intrappolare pezzi in modi complessi quindi controlla sempre le catture rosse e gli intrappolamenti viola!',
    octopusEntangle: 'Il Polpo può intrappolare pezzi nemici adiacenti, immobilizzandoli, può persino muoversi di una casella e intrappolare nemici!',
    octopusEntanglePost: 'I pezzi intrappolati non possono muoversi finché il Polpo non si allontana o viene catturato',
    octopusInk: 'Il Polpo può usare inchiostro per sfuggire a situazioni pericolose, creando fino a 3 ombre',
    octopusInkPost: 'Confondendo il nemico e permettendo giochi di esca ed evasione interessanti',

    // Penguin
    penguinMovement: 'Il Pinguino scivola in linea retta nella sua direzione impostata finché un muro o un pezzo blocca il suo movimento',
    penguinMovementPost: 'Dopo essersi mosso, il Pinguino può impostare la sua direzione finale anche nello stesso turno',
    penguinRotate: 'All\'inizio della partita un Pinguino è rivolto verso il basso e deve ruotare prima di poter scivolare, noto anche come dormiente',
    penguinRotatePost: 'Il pinguino in qualsiasi posizione può scegliere di ruotare invece di muoversi',
    penguinBirdType: 'Il Pinguino ha capacità di cattura limitate, come la Gru, non può catturare pezzi grandi o predatori come Albero, Rinoceronte, Orso o Lupo',
    penguinBirdTypePost: 'Dopo la cattura, il Pinguino può ruotare per affrontare qualsiasi direzione per il posizionamento strategico',

    // Rhino
    rhinoMovement: 'Il Rinoceronte si muove di due caselle in avanti solamente',
    rhinoMovementPost: 'Non può muoversi solo di 1 casella',
    rhinoBackStep: 'Il Rinoceronte può muoversi indietro-sinistra o indietro-destra',
    rhinoCharge: 'Il Rinoceronte una volta per partita può viaggiare una casella extra in avanti usando la sua abilità carica',
    rhinoChargePost: 'Portando a un potenziale di movimento e cattura devastante',
    rhinoTrample: 'Il Rinoceronte cattura tutti i pezzi nel suo percorso di viaggio con Calpestamento',
    rhinoTramplePost: 'Inclusa una Capra svenuta',
    rhinoLane: 'Il Rinoceronte può scambiare posizioni con un altro pezzo alleato permettendo giochi strategici di corsia',
    rhinoLanePost: 'Ma solo se il Rinoceronte e il pezzo Alleato non si sono entrambi mossi',

    // Snake
    snakeMovement: 'Il Serpente può muoversi di 2 caselle in qualsiasi linea retta',
    snakeMovementPost: 'Il Serpente si muove esattamente di 2 caselle a meno che non sia bloccato da un muro o un pezzo alleato',
    snakeMoveBlocks: 'Quando bloccato da un muro o un pezzo che non può catturare, il movimento del Serpente si accorcia a 1 casella',
    snakeMoveBlocksPost: 'Può comunque muoversi di due caselle anche se c\'è un pezzo intermediario',
    snakeStrike: 'Il Serpente può colpire 3 caselle in avanti se c\'è un animale nemico',
    snakeStrikePost: 'Purché nessun pezzo intermediario blocchi il suo percorso',
    snakeShedskin: 'Una volta per partita, il Serpente può fare la muta della pelle e tornare alla prima fila se la casella è libera',
    snakeShedskinPost: 'Questa rinascita dà al Serpente una vita extra ogni partita',

    // Tree
    treeMovement: 'L\'Albero può muoversi di una casella in avanti o a qualsiasi casella sulla sua fila da un lato all\'altro',
    treeMovementPost: 'Fintanto che il suo percorso non è bloccato',
    treeHouse: 'L\'Albero può ospitare altri pezzi, proteggendoli dai nemici che non possono arrampicarsi sugli Alberi. Forse i pezzi possono arrampicarsi come Orso, Gru, Rana, Funghi, Capra, Scimmia, Polpo e Serpente',
    treeHousePost: 'Quando un pezzo che può arrampicarsi su un albero attacca, cattura solo il pezzo ospitato, proteggendo l\'Albero',
    treeTrample: 'L\'Albero come il Rinoceronte, cattura tutti i pezzi in una casella quando si muove',
    treeTramplePost: 'Questo include una Capra svenuta',
    treePlant: 'L\'Albero è una pianta, non un animale, quindi è immune a diversi effetti',
    treePlantPost: 'Come veleno, zombificazione, intrappolamento e infezione da virus!',

    // Virus
    virusMovement: 'Il Virus può muoversi solo su caselle occupate da animali, che sono a due caselle di distanza',
    virusMoveBlocks: 'Il Virus può muoversi solo di una casella se è accanto a un muro',
    virusCaptureHost: 'Quando il Virus atterra su (dentro) qualsiasi pezzo animale, li infetta solo, possono ancora continuare il gioco regolare mentre infetti',
    virusCaptureHostPost: 'Il Virus cattura il pezzo solo quando lascia l\'ospite infetto',
    virusContagion: 'Il Virus può diffondersi rapidamente infettando più ospiti in un singolo turno',
    virusContagionPost: 'Il Contagio permette al Virus di fare tutte le mosse legali che desidera ogni turno',

    // Wolf
    wolfMovement: 'Il Lupo può muoversi a forma di L, come il cavallo negli scacchi',
    wolfMovementPost: 'Non è ostruito da nessun altro pezzo',
    wolfLoneWolf: 'Lupo',
    wolfLoneWolfPost: 'Il Lupo si considera anche solitario quando ha ancora una Capra svenuta o un alleato virus',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Trascina per esplorare • Pizzica per zoomare',
    dragToExploreDesktop: '🖱️ Trascina per esplorare • Scorri per zoomare',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Indietro',
    next: 'Avanti',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'SANDBOX',
    description: 'Sperimenta e Pratica',
    mode: 'Modalità:',
    modeValue: 'Sandbox',
    status: 'Stato:',
    statusReady: 'Pronto',
    clearBoard: 'Pulisci Tavola',
  },

  // Multiplayer
  multiplayer: {
    title: 'MULTIGIOCATORE',
    description: 'Trova la tua partita e competi!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Partite di Posizionamento',
    matchProgress: 'Progresso Partita',
    gamesCompleted: '{games} / 10 Partite Completate',
    estimatedFinalRating: 'Valutazione Finale Stimata',
    startingRating: 'Valutazione iniziale',
    matchesRemaining: '{matches} partite rimanenti',
    findPlacementMatch: 'Trova Partita di Posizionamento',

    // Matchmaking modes
    findMatch: 'Trova Partita',
    competitive: 'Competitivo',
    competitiveDesc: 'Trova avversari vicini alla tua classifica',
    quick: 'Veloce',
    quickDesc: 'Trova partite competitive rapidamente',
    casual: 'Casuale',
    casualDesc: 'Senza classifica - gioca per divertimento!',
    placement: 'Posizionamento',
    placementDesc: 'Completa 10 partite per ottenere un rango',
    startSearch: 'Inizia Ricerca',

    // Searching
    searching: 'Cercando...',
    mode: 'Modalità:',
    inQueue: 'In Coda:',
    players: 'giocatore',
    playersPlural: 'giocatori',
    cancelSearch: 'Annulla Ricerca',

    // Game info
    status: 'Stato:',
    ready: 'Pronto',
    selectingKing: 'Selezionando Re',
    placingPieces: 'Piazzando Pezzi',
    playing: 'In Gioco',
    gameType: 'Tipo di Gioco:',
    opponent: 'Avversario:',
    opponentElo: 'ELO Avversario:',
    unranked: 'Senza Classifica',

    // Piece placement
    dragPieces: 'Trascina i pezzi sulla tavola',
    lightPieces: 'Pezzi Chiari (Tu)',
    darkPieces: 'Pezzi Scuri (Tu)',

    // Waiting states
    waitingForOpponent: 'Aspettando l\'Avversario...',
    waitingForKing: 'Aspettando che l\'avversario selezioni il suo re...',

    // Warnings
    invalidPlacement: 'Posizionamento Non Valido',
    lightTurn: 'È il turno del giocatore Chiaro!',
    darkTurn: 'È il turno del giocatore Scuro!',
    onlyLightPieces: 'Puoi piazzare solo pezzi chiari!',
    onlyDarkPieces: 'Puoi piazzare solo pezzi scuri!',
    mustPlaceOnRow: 'I pezzi {color} devono essere piazzati sulla fila {row}!',

    // Chat
    chat: 'Chat',
    typeMessage: 'Scrivi un messaggio...',
    send: 'Invia',
  },

  // Main Page
  mainPage: {
    title: 'SCACCHI ANIMALI',
    subtitle: 'Un gioco per umani',
    playersOnline: 'Giocatori attualmente online',
    placement: 'Posizionamento',
    placementProgress: 'Posizionamento',
    challengeAI: 'Sfida IA',
    multiplayer: 'Multigiocatore',
    sandbox: 'Sandbox',
    tutorials: 'Tutorial',
    shop: 'Negozio',
    collection: 'Collezione',
    history: 'Cronologia',
    analytics: 'Statistiche',
    courses: 'Corsi',
    upgradeAccount: 'Aggiorna account',
    signIn: 'Accedi',
    playAsGuest: 'Gioca come Ospite',
    welcomeBack: 'Bentornato! Di solito giochi come',

    // Learn the Pieces section
    learnThePieces: 'Impara i pezzi',

    // Learn the Rules section
    learnTheRules: 'Impara le Regole',
    premiseTitle: 'Premessa',
    premiseText: 'Zodiac è un\'alternativa agli scacchi con un re NASCOSTO da un roster di 13 pezzi, seleziona un roster unico e poi bluffa il tuo avversario per sconfiggerlo su una tavola 5 per 8',
    selectionTitle: 'Selezione',
    selectionText: 'Per iniziare una partita, scegli segretamente il tuo re, poi piazza i tuoi 5 pezzi alternandoli con il tuo avversario per creare uno degli oltre 500 miliardi di stati iniziali.',
    objectiveTitle: 'Obiettivo',
    objectiveText: 'O leggi il tuo avversario per CATTURARE il suo re segreto o FAI CORRERE il tuo re attraverso la tavola per assicurarti la vittoria!',
    competeTitle: 'Competi',
    competeText: 'Testa le tue abilità sulla classifica, sviluppa nuove tecniche e strategie personali, sali di livello per affrontare i migliori!',
    fullRulesButton: 'Per le regole ufficiali complete clicca qui',

    // FAQ section
    faqTitle: 'Domande Frequenti',
    faqQuestion1: 'Qual è l\'idea dietro gli scacchi Zodiac?',
    faqAnswer1: 'Gli scacchi Zodiac sono stati ispirati inizialmente dalle parole di Bobby Fischer sulla sua ispirazione per creare Chess960, volevamo espandere l\'idea di combattere la memorizzazione meccanica e celebrare l\'intuizione umana in una profondità insondabile!',
    faqQuestion2: 'Perché abbiamo bisogno di un\'alternativa agli scacchi',
    faqAnswer2: 'Non ne abbiamo bisogno! Zodiac non vuole distogliere le persone dal giocare a scacchi! È un\'opzione diversa con i suoi punti di forza e debolezza, speriamo che tu ti diverta e ci aiuti ad adattare questo gioco per ravvivare il gioco nuovo',
    faqQuestion3: 'Come si vince negli Scacchi Zodiac?',
    faqAnswer3: 'Ci sono tre modi per vincere: catturare il pezzo re nascosto del tuo avversario, far correre il tuo re verso il lato opposto della tavola, o in una partita con controlli del tempo, far scadere il tempo del tuo avversario',
    faqQuestion4: 'È questa una FAQ?',
    faqAnswer4: 'Sì, puoi guardare qualsiasi delle domande elencate nelle FAQ e se vuoi maggiori dettagli, puoi cliccare sulle domande e poi leggere i dettagli seguenti, come questi dettagli che stai leggendo ora',
    faqQuestion5: 'Quanto dura tipicamente una partita?',
    faqAnswer5: 'Ogni partita è molto diversa! Alcune partite finiscono in 2 mosse e alcune potrebbero richiedere 30 minuti, tipicamente tendiamo a trovarle nella fascia di 5-15 minuti!',
    faqQuestion6: 'Cosa succede se nessuno può fare una mossa legale?',
    faqAnswer6: 'Se un giocatore non può fare alcuna mossa legale (stallo), la partita finisce in pareggio. La partita può anche finire in pareggio attraverso la ripetizione (stesso stato della tavola 3 volte) o per accordo reciproco tra i giocatori!',

    // About section
    aboutButton: 'Informazioni',
    privacyPolicy: 'Politica sulla Privacy',
    developerInterface: 'Interfaccia Sviluppatore',
  },

  // About Modal
  about: {
    title: 'Informazioni su Zodiac',
    paragraph1: 'Zodiac è un gioco da tavolo simile agli scacchi che combina elementi di selezione dei pezzi da giochi come LoL e DotA, con meccaniche di bluff dal poker o giochi di deduzione sociale.',
    paragraph2: 'Le prime versioni del gioco sono state create nel 2014, con il nome Shadow Chess. Nel 2018 è stato ridisegnato per essere quello che vedi oggi, con un roster di pezzi divertenti con schemi di movimento e abilità equilibrati ma unici.',
    paragraph3: 'La nostra visione è registrare tutti i dati di gioco degli utenti per continuare a far evolvere il gioco nel tentativo di mantenere il gameplay rinfrescante, incoraggiando giochi nuovi.',
    paragraph4: 'Con lo spazio di ricerca gigante di Zodiac, le informazioni nascoste e le posizioni iniziali della tavola speriamo di respingere il dominio dell\'IA e mantenere zodiac un gioco per umani!',
  },

  // Privacy Policy
  privacy: {
    title: 'Politica sulla Privacy',
    lastUpdated: 'Ultimo Aggiornamento',

    introduction: {
      title: 'Introduzione',
      p1: 'Benvenuto in Zodiac Chess ("noi", "nostro" o "ci"). Siamo impegnati a proteggere la tua privacy e assicurarti un\'esperienza di gioco sicura e piacevole. Questa Politica sulla Privacy spiega come raccogliamo, utilizziamo, divulghiamo e proteggiamo le tue informazioni quando usi il nostro sito web e gioco.',
      p2: 'Utilizzando Zodiac Chess, accetti la raccolta e l\'uso delle informazioni in conformità con questa politica. Se non sei d\'accordo con le nostre politiche e pratiche, ti preghiamo di non utilizzare il nostro servizio.',
      contact: 'Contattaci a:',
    },

    infoCollect: {
      title: 'Informazioni che Raccogliamo',
      accountInfo: {
        title: '1. Informazioni sull\'Account',
        item1: 'Indirizzo Email: Richiesto per la creazione dell\'account e la comunicazione',
        item2: 'Nome Utente: Il tuo nome visualizzato scelto',
        item3: 'Password: Criptata e archiviata in modo sicuro',
      },
      gameData: {
        title: '2. Dati di Gioco',
        item1: 'Statistiche di Gioco: Vittorie, sconfitte, valutazione ELO, progresso delle partite di posizionamento',
        item2: 'Dati di Gameplay: Selezioni di pezzi, mosse effettuate, strategie utilizzate',
        item3: 'Cronologia Partite: Registrazioni delle partite giocate, avversari affrontati',
        item4: 'Acquisti In-Game: Oggetti cosmetici e stato di abbonamento premium',
      },
      technicalData: {
        title: '3. Dati Tecnici',
        item1: 'Informazioni sul Dispositivo: Tipo di browser, sistema operativo',
        item2: 'Dati di Utilizzo: Pagine visitate, tempo trascorso, funzionalità utilizzate',
        item3: 'Archiviazione Locale: Preferenze linguistiche, impostazioni UI, stato temporaneo del gioco',
      },
    },

    children: {
      title: 'Privacy dei Bambini (Conformità COPPA)',
      p1: 'Zodiac Chess è progettato per essere adatto alle famiglie e adatto a giocatori di tutte le età, inclusi i bambini. Prendiamo particolare cura nel rispettare il Children\'s Online Privacy Protection Act (COPPA).',
      p2: 'Per gli utenti di età inferiore ai 13 anni: raccomandiamo che i bambini utilizzino la nostra modalità di gioco ospite, che non richiede la creazione di un account o la raccolta di dati. Gli account ospite non hanno accesso alle funzionalità di chat testuale, garantendo che i bambini non siano esposti alla comunicazione con il più ampio internet. Se un bambino crea un account, richiediamo il consenso dei genitori prima di raccogliere qualsiasi informazione personale.',
      p3: 'NON raccogliamo, utilizziamo o condividiamo consapevolmente informazioni personali di bambini di età inferiore ai 13 anni senza il consenso verificato dei genitori.',
      p4: 'Sicurezza Chat: La chat testuale è automaticamente disabilitata per tutti gli account ospite/temporanei. I titolari di account standard hanno l\'opzione di disabilitare la funzionalità di chat nelle impostazioni del loro account in qualsiasi momento.',
      parentalRights: 'I genitori hanno il diritto di:',
      right1: 'Rivedere le informazioni personali del loro figlio',
      right2: 'Richiedere la cancellazione dei dati del loro figlio',
      right3: 'Rifiutare ulteriore raccolta o uso delle informazioni del loro figlio',
      contactUs: 'Per esercitare questi diritti o se ritieni che tuo figlio ci abbia fornito informazioni personali, contattaci immediatamente a contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Come Utilizziamo le Tue Informazioni',
      item1: 'Fornire e migliorare i nostri servizi di gioco',
      item2: 'Abbinarti con avversari appropriati in base al livello di abilità',
      item3: 'Tracciare i tuoi progressi, statistiche e risultati',
      item4: 'Elaborare pagamenti per abbonamenti premium e oggetti cosmetici',
      item5: 'Inviare importanti annunci di servizio e aggiornamenti',
      item6: 'Analizzare i dati di gameplay per migliorare l\'equilibrio del gioco e le funzionalità',
    },

    thirdParty: {
      title: 'Servizi di Terze Parti',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Utilizziamo Firebase per l\'autenticazione, l\'archiviazione del database e le funzionalità multigiocatore. Firebase può raccogliere determinati dati come descritto nella loro politica sulla privacy.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Utilizziamo Stripe per elaborare i pagamenti per abbonamenti premium e acquisti in-app. Stripe gestisce tutte le informazioni sulla carta di pagamento - non vediamo né archiviamo mai i tuoi dettagli di pagamento completi.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Il nostro sito web è ospitato su Netlify, che può raccogliere dati standard di hosting web come indirizzi IP e log di accesso.',
      },
      adsense: {
        title: 'Google AdSense (Futuro)',
        description: 'Potremmo visualizzare pubblicità tramite Google AdSense. Questi annunci possono utilizzare cookie per la personalizzazione. Per i contenuti diretti ai bambini, mostreremo solo annunci non personalizzati in conformità con COPPA.',
      },
      viewPolicy: 'Visualizza la loro Politica sulla Privacy',
    },

    cookies: {
      title: 'Cookie e Archiviazione Locale',
      description: 'Utilizziamo l\'archiviazione locale del browser (simile ai cookie) per migliorare la tua esperienza:',
      item1: 'Preferenza Lingua: Ricorda la tua lingua selezionata',
      item2: 'Sessione Account: Ti mantiene connesso (funziona con Firebase)',
      item3: 'Impostazioni di Gioco: Ricorda le tue preferenze UI e configurazioni sandbox',
      item4: 'Cookie Pubblicitari: Se acconsenti, i servizi pubblicitari di terze parti possono utilizzare cookie per la personalizzazione degli annunci',
    },

    security: {
      title: 'Sicurezza dei Dati',
      p1: 'Implementiamo misure di sicurezza appropriate per proteggere le tue informazioni:',
      item1: 'Crittografia Password: Tutte le password sono crittografate utilizzando metodi standard del settore',
      item2: 'Connessioni Sicure: Crittografia HTTPS per tutta la trasmissione dei dati',
      item3: 'Regole di Sicurezza Firebase: Controlli di accesso al database rigorosi',
      p2: 'Tuttavia, nessun metodo di trasmissione su internet è sicuro al 100%. Mentre ci sforziamo di proteggere i tuoi dati, non possiamo garantire la sicurezza assoluta.',
    },

    retention: {
      title: 'Conservazione dei Dati',
      p1: 'Conserviamo i tuoi dati come segue:',
      item1: 'Account Attivi: I dati vengono conservati mentre il tuo account è attivo',
      item2: 'Account Inattivi: Se il tuo account è inattivo per 10 anni, potremmo eliminare i tuoi dati',
    },

    rights: {
      title: 'I Tuoi Diritti sulla Privacy',
      description: 'A seconda della tua posizione, potresti avere i seguenti diritti:',
      access: {
        title: 'Accesso:',
        description: 'Richiedere una copia dei tuoi dati personali',
      },
      correction: {
        title: 'Correzione:',
        description: 'Richiedere correzioni ai tuoi dati',
      },
      deletion: {
        title: 'Cancellazione:',
        description: 'Richiedere la cancellazione del tuo account e dei dati',
      },
      portability: {
        title: 'Portabilità dei Dati:',
        description: 'Richiedere i tuoi dati in un formato portatile',
      },
      optOut: {
        title: 'Opt-Out:',
        description: 'Rinunciare alle comunicazioni di marketing',
      },
      contact: 'Per esercitare uno qualsiasi di questi diritti, contattaci a contact@zodiac-chess.com',
    },

    international: {
      title: 'Utenti Internazionali',
      p1: 'Zodiac Chess è gestito dalla Nuova Zelanda. Se stai accedendo al nostro servizio da fuori della Nuova Zelanda, tieni presente che le tue informazioni potrebbero essere trasferite, archiviate ed elaborate in Nuova Zelanda e in altri paesi in cui operano i nostri fornitori di servizi.',
      p2: 'Utilizzando il nostro servizio, acconsenti al trasferimento delle tue informazioni in paesi al di fuori del tuo paese di residenza, che potrebbero avere leggi sulla protezione dei dati diverse.',
    },

    changes: {
      title: 'Modifiche a Questa Politica sulla Privacy',
      description: 'Potremmo aggiornare questa Politica sulla Privacy di tanto in tanto. Ti informeremo di eventuali modifiche pubblicando la nuova Politica sulla Privacy su questa pagina e aggiornando la data di "Ultimo Aggiornamento". Le modifiche significative saranno comunicate tramite email o un avviso prominente sul nostro sito web.',
    },

    contact: {
      title: 'Contattaci',
      description: 'Se hai domande, dubbi o richieste riguardanti questa Politica sulla Privacy o le nostre pratiche sui dati, contattaci:',
      email: 'Email:',
      company: 'Azienda:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Termini di Servizio',
    lastUpdated: 'Ultimo Aggiornamento',
    back: 'Indietro',
    viewPrivacyPolicy: 'Visualizza Informativa sulla Privacy',
    acknowledgment: 'Utilizzando Zodiac Chess, riconosci di aver letto, compreso e accetti di essere vincolato da questi Termini di Servizio.',
    acceptance: {
      title: '1. Accettazione dei Termini',
      p1: 'Accedendo e utilizzando Zodiac Chess (il "Servizio"), accetti e acconsenti ad essere vincolato da questi Termini di Servizio. Se non accetti questi termini, ti preghiamo di non utilizzare il Servizio.',
      p2: 'Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. L\'uso continuato del Servizio dopo le modifiche costituisce accettazione dei termini modificati.',
    },
    description: {
      title: '2. Descrizione del Servizio',
      p1: 'Zodiac Chess è un gioco da tavolo strategico online con pezzi animali unici dotati di abilità speciali. Il Servizio include:',
      feature1: 'Gioco per giocatore singolo contro avversari IA',
      feature2: 'Matchmaking multiplayer e gioco competitivo',
      feature3: 'Tutorial interattivi e risorse di apprendimento',
      feature4: 'Creazione account e tracciamento progressi',
      feature5: 'Funzionalità di abbonamento premium opzionali',
      feature6: 'Opzioni di personalizzazione estetica',
    },
    accounts: {
      title: '3. Account Utente',
      eligibility: {
        title: '3.1 Idoneità',
        p1: 'Devi avere almeno 13 anni per creare un account. Gli utenti sotto i 13 anni possono utilizzare la modalità ospite con supervisione dei genitori ma non possono creare account.',
      },
      responsibilities: {
        title: '3.2 Sicurezza dell\'Account',
        p1: 'Sei responsabile di:',
        item1: 'Mantenere la riservatezza della tua password',
        item2: 'Tutte le attività che si verificano sotto il tuo account',
        item3: 'Notificarci immediatamente di qualsiasi uso non autorizzato',
        p2: 'Non siamo responsabili per perdite o danni derivanti da accesso non autorizzato all\'account.',
      },
      prohibited: {
        title: '3.3 Attività Proibite',
        p1: 'NON puoi:',
        item1: 'Condividere il tuo account con altri',
        item2: 'Usare account multipli per manipolare le classifiche',
        item3: 'Usare bot, script o strumenti automatizzati per giocare',
        item4: 'Molestare, abusare o minacciare altri giocatori',
        item5: 'Sfruttare bug o glitch per vantaggi sleali',
        item6: 'Fare reverse engineering o tentare di accedere al nostro codice sorgente',
        p2: 'La violazione di queste regole può comportare la sospensione dell\'account o il ban permanente.',
      },
    },
    premium: {
      title: '4. Abbonamenti Premium',
      billing: {
        title: '4.1 Fatturazione',
        p1: 'Gli abbonamenti premium sono elaborati tramite Stripe. Acquistando un abbonamento premium, ci autorizzi ad addebitare il tuo metodo di pagamento su base ricorrente fino alla cancellazione.',
        p2: 'Le tariffe di abbonamento sono:',
        item1: 'Piano Mensile: Addebitato mensilmente nell\'anniversario della data di acquisto',
        item2: 'Piano Annuale: Addebitato annualmente nell\'anniversario della data di acquisto',
        p3: 'I prezzi sono soggetti a modifiche con 30 giorni di preavviso agli abbonati attivi.',
      },
      cancellation: {
        title: '4.2 Cancellazione',
        p1: 'Puoi cancellare il tuo abbonamento in qualsiasi momento tramite le impostazioni dell\'account o contattando il supporto. La cancellazione ha effetto alla fine del periodo di fatturazione corrente.',
        p2: 'Manterrai le funzionalità premium fino alla fine del periodo pagato, anche dopo la cancellazione.',
      },
      refunds: {
        title: '4.3 Rimborsi',
        p1: 'Abbonamenti mensili: Nessun rimborso per mesi parziali. Cancella in qualsiasi momento per interrompere gli addebiti futuri.',
        p2: 'Abbonamenti annuali: Rimborso completo se richiesto entro 7 giorni dall\'acquisto. Dopo 7 giorni, i rimborsi sono a nostra discrezione.',
        p3: 'Acquisti estetici: Generalmente non rimborsabili. Contatta il supporto per circostanze eccezionali.',
      },
    },
    acceptable: {
      title: '5. Politica di Utilizzo Accettabile',
      p1: 'Accetti di utilizzare Zodiac Chess in modo rispettoso e legale. I comportamenti proibiti includono:',
      item1: 'Barare, hackerare o sfruttare le meccaniche di gioco',
      item2: 'Molestie, discorsi d\'odio o linguaggio discriminatorio',
      item3: 'Spam, pubblicità o sollecitazione',
      item4: 'Condivisione di contenuti inappropriati (se la chat o i contenuti generati dagli utenti sono abilitati)',
      item5: 'Impersonare altri utenti o membri dello staff',
      item6: 'Tentare di interrompere o danneggiare il Servizio',
      p2: 'Ci riserviamo il diritto di indagare sulle violazioni e intraprendere azioni appropriate, inclusa la terminazione dell\'account e la segnalazione alle autorità se necessario.',
    },
    intellectual: {
      title: '6. Diritti di Proprietà Intellettuale',
      ownership: {
        title: '6.1 I Nostri Contenuti',
        p1: 'Tutti i contenuti del gioco, inclusi ma non limitati a meccaniche di gioco, artwork, animazioni, effetti sonori, codice e design, sono di proprietà di Animal Chess Limited o dei nostri licenzianti.',
        p2: 'Ti viene concessa una licenza limitata, non esclusiva e non trasferibile per utilizzare il Servizio solo per scopi di intrattenimento personale.',
      },
      userContent: {
        title: '6.2 Contenuti dell\'Utente',
        p1: 'Inviando contenuti (come messaggi di chat, nomi utente o informazioni del profilo), ci concedi una licenza mondiale e royalty-free per utilizzare, visualizzare e distribuire tali contenuti in relazione al Servizio.',
        p2: 'Dichiari di possedere o avere i diritti necessari su qualsiasi contenuto che invii.',
      },
    },
    disclaimers: {
      title: '7. Esclusioni di Garanzia e Limitazioni di Responsabilità',
      p1: 'IL SERVIZIO È FORNITO "COSÌ COM\'È" SENZA GARANZIE DI ALCUN TIPO, ESPRESSE O IMPLICITE.',
      p2: 'Non garantiamo che:',
      item1: 'Il Servizio sarà ininterrotto o privo di errori',
      item2: 'I difetti saranno corretti',
      item3: 'Il Servizio sia privo di virus o componenti dannosi',
      item4: 'I risultati dell\'utilizzo del Servizio soddisferanno le tue aspettative',
      p3: 'NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE, NON SIAMO RESPONSABILI PER:',
      item5: 'Qualsiasi danno indiretto, incidentale o consequenziale',
      item6: 'Perdita di profitti, dati o avviamento',
      item7: 'Interruzioni del servizio o perdita di dati',
      item8: 'Danni superiori all\'importo che ci hai pagato negli ultimi 12 mesi',
    },
    privacy: {
      title: '8. Privacy',
      p1: 'Il tuo utilizzo del Servizio è anche regolato dalla nostra Informativa sulla Privacy, che spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni personali.',
      p2: 'Utilizzando il Servizio, acconsenti alle nostre pratiche sui dati come descritto nell\'Informativa sulla Privacy.',
    },
    changes: {
      title: '9. Modifiche ai Termini',
      p1: 'Ci riserviamo il diritto di modificare questi Termini di Servizio in qualsiasi momento. Informeremo gli utenti di modifiche sostanziali tramite:',
      item1: 'Notifica via email agli utenti registrati',
      item2: 'Avviso prominente sul sito web',
      item3: 'Data "Ultimo Aggiornamento" aggiornata in cima a questa pagina',
      p2: 'Il tuo uso continuato del Servizio dopo le modifiche costituisce accettazione dei termini modificati.',
    },
    governing: {
      title: '10. Legge Applicabile',
      p1: 'Questi Termini di Servizio sono regolati dalle leggi della Nuova Zelanda, senza riguardo ai principi di conflitto di leggi.',
      p2: 'Qualsiasi controversia derivante da questi termini o dal tuo utilizzo del Servizio sarà risolta nei tribunali della Nuova Zelanda.',
    },
    contact: {
      title: '11. Informazioni di Contatto',
      p1: 'Per domande, dubbi o supporto riguardo questi Termini di Servizio:',
      email: 'Email:',
      company: 'Azienda:',
      address: 'Indirizzo:',
    },
    severability: {
      title: '12. Separabilità',
      p1: 'Se qualsiasi disposizione di questi termini viene ritenuta inapplicabile o non valida, tale disposizione sarà limitata o eliminata nella misura minima necessaria, e le restanti disposizioni rimarranno in pieno vigore ed effetto.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Politica sui Cookie',
    lastUpdated: 'Ultimo Aggiornamento',
    browserInstructions: {
      chrome: 'Impostazioni → Privacy e Sicurezza → Cookie',
      firefox: 'Impostazioni → Privacy e Sicurezza → Cookie e Dati dei Siti',
      safari: 'Preferenze → Privacy → Cookie e dati del sito web',
      edge: 'Impostazioni → Privacy, ricerca e servizi → Cookie',
    },
    cookieTable: {
      name: 'Nome Cookie',
      purpose: 'Scopo',
      duration: 'Durata',
      type: 'Tipo',
    },
    relatedPolicies: {
      title: 'Politiche Correlate',
      description: 'Per maggiori informazioni su come gestiamo i tuoi dati, consulta:',
      privacy: 'Informativa sulla Privacy',
      terms: 'Termini di Servizio',
    },

    introduction: {
      title: 'Introduzione',
      p1: 'Questa Politica sui Cookie spiega come Zodiac Chess ("noi", "nostro" o "ci") utilizza i cookie e tecnologie simili quando visiti il nostro sito web.',
      p2: 'Utilizzando il nostro sito web, acconsenti al nostro utilizzo dei cookie in conformità con questa politica. Se non sei d\'accordo, disabilita i cookie nelle impostazioni del tuo browser o non utilizzare il nostro sito web.',
    },
    what: {
      title: 'Cosa Sono i Cookie?',
      p1: 'I cookie sono piccoli file di testo che vengono inseriti sul tuo dispositivo (computer, smartphone, tablet) quando visiti un sito web. Sono ampiamente utilizzati per far funzionare i siti web in modo efficiente e fornire informazioni ai proprietari dei siti.',
      p2: 'I cookie servono a vari scopi, tra cui ricordare le tue preferenze, analizzare l\'utilizzo del sito e abilitare determinate funzionalità.',
    },
    types: {
      title: 'Tipi di Cookie che Utilizziamo',
      necessary: {
        title: '1. Cookie Necessari',
        description: 'Questi cookie sono essenziali per il corretto funzionamento del sito web. Senza questi cookie, i servizi che hai richiesto non possono essere forniti.',
        examples: 'Esempi:',
        item1: 'Cookie di autenticazione - Ti mantengono connesso al tuo account',
        item2: 'Cookie di sicurezza - Proteggono da attività fraudolente',
        item3: 'Cookie di sessione - Mantengono lo stato del gioco durante una sessione',
        item4: 'Preferenze di consenso ai cookie - Ricordano le tue scelte sui cookie',
      },
      analytics: {
        title: '2. Cookie Analitici',
        description: 'Questi cookie ci aiutano a capire come i visitatori interagiscono con il nostro sito web raccogliendo informazioni anonime su visite alle pagine, tempo trascorso e funzionalità utilizzate.',
        provider: 'Fornitore: Firebase Analytics (Google)',
        purpose: 'Scopo:',
        item1: 'Misurare il traffico del sito web e il coinvolgimento degli utenti',
        item2: 'Identificare funzionalità e pagine popolari',
        item3: 'Comprendere i dati demografici degli utenti (fascia d\'età, posizione generale)',
        item4: 'Migliorare le prestazioni del sito web e l\'esperienza utente',
      },
      advertising: {
        title: '3. Cookie Pubblicitari',
        description: 'Questi cookie vengono utilizzati per mostrare pubblicità pertinenti per te. Limitano anche il numero di volte in cui vedi un annuncio e aiutano a misurare l\'efficacia delle campagne pubblicitarie.',
        provider: 'Fornitore: Google AdSense',
        purpose: 'Scopo:',
        item1: 'Mostrare annunci personalizzati in base ai tuoi interessi',
        item2: 'Misurare le prestazioni e il coinvolgimento degli annunci',
        item3: 'Evitare di mostrare lo stesso annuncio troppe volte',
        note: 'Nota: Gli abbonati Premium non vedono mai pubblicità, indipendentemente dalle impostazioni dei cookie.',
      },
    },
    firstThird: {
      title: 'Cookie di Prima Parte vs Cookie di Terze Parti',
      firstParty: {
        title: 'Cookie di Prima Parte',
        description: 'Questi sono cookie impostati direttamente da Zodiac Chess. Li utilizziamo per le funzionalità essenziali del sito, l\'autenticazione e per ricordare le tue preferenze.',
      },
      thirdParty: {
        title: 'Cookie di Terze Parti',
        description: 'Questi sono cookie impostati da servizi esterni che utilizziamo, come Google Analytics e Google AdSense. I cookie di terze parti sono soggetti alle politiche sulla privacy di tali fornitori.',
      },
    },
    specific: {
      title: 'Cookie Specifici che Utilizziamo',
      tableHeader: 'Di seguito è riportato un elenco dettagliato dei cookie utilizzati sul nostro sito web:',
    },
    control: {
      title: 'Come Controllare i Cookie',
      consent: {
        title: '1. Banner di Consenso ai Cookie',
        description: 'Quando visiti il nostro sito web per la prima volta, vedrai un banner di consenso ai cookie. Puoi:',
        item1: 'Accetta Tutti - Consenti tutti i cookie (necessari, analitici e pubblicitari)',
        item2: 'Rifiuta Opzionali - Consenti solo i cookie necessari (nessun analytics o annunci)',
        item3: 'Personalizza - Scegli esattamente quali tipi di cookie vuoi consentire',
      },
      browser: {
        title: '2. Impostazioni del Browser',
        description: 'La maggior parte dei browser web ti consente di controllare i cookie attraverso le loro impostazioni. Puoi:',
        item1: 'Bloccare tutti i cookie',
        item2: 'Accettare solo i cookie di prima parte',
        item3: 'Eliminare i cookie dopo ogni sessione di navigazione',
        item4: 'Visualizzare ed eliminare i singoli cookie',
        links: 'Ecco i link alla gestione dei cookie per i browser più popolari:',
      },
      optOut: {
        title: '3. Strumenti di Opt-Out',
        description: 'Per i cookie pubblicitari in particolare, puoi disattivare gli annunci personalizzati:',
        googleLink: 'Impostazioni Annunci Google',
        googleDesc: ' - Gestisci gli annunci personalizzati di Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Disattiva la pubblicità basata sugli interessi',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Strumento di opt-out specifico per l\'UE',
      },
    },
    impact: {
      title: 'Impatto della Disabilitazione dei Cookie',
      p1: 'Se disabiliti o rifiuti i cookie, tieni presente che:',
      item1: 'Alcune parti del sito web potrebbero non funzionare correttamente',
      item2: 'Potresti dover reinserire le tue preferenze ad ogni visita',
      item3: 'Potresti essere disconnesso dal tuo account',
      item4: 'I cookie necessari sono richiesti per il funzionamento del sito - disabilitarli ti impedirà di utilizzare le funzionalità principali',
    },
    updates: {
      title: 'Aggiornamenti a Questa Politica sui Cookie',
      p1: 'Potremmo aggiornare questa Politica sui Cookie di tanto in tanto per riflettere cambiamenti nelle nostre pratiche o per motivi legali, normativi o operativi.',
      p2: 'Ti informeremo di modifiche significative aggiornando la data di "Ultimo Aggiornamento" in cima a questa pagina. Ti preghiamo di rivedere periodicamente questa politica.',
    },
    contact: {
      title: 'Contattaci',
      p1: 'Se hai domande sul nostro utilizzo dei cookie o su questa Politica sui Cookie, contattaci:',
      email: 'Email:',
      company: 'Azienda:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Pinguino',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'Orso',
    Crane: 'Gru',
    Frog: 'Rana',
    Fungi: 'Fungo',
    Goat: 'Capra',
    Monkey: 'Scimmia',
    Octopus: 'Polpo',
    Penguin: 'Pinguino',
    Rhino: 'Rinoceronte',
    Snake: 'Serpente',
    Tree: 'Albero',
    Virus: 'Virus',
    Wolf: 'Lupo',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
